<script setup lang="ts">
import { Popover, PopoverTrigger, IconButton } from '@laam/ui/base';
import { PhCaretDown, PhCaretRight } from '@phosphor-icons/vue';

defineEmits<{
	(e: 'menu-clicked', href: string): void;
}>();

const open = ref(false);
</script>
<template>
	<Popover v-model:open="open">
		<PopoverTrigger as-child>
			<IconButton
				variant="icon"
				class="!p-0"
				@click.stop="(e) => e.stopPropagation()"
				@click.prevent="(e) => e.stopPropagation()"
			>
				<PhCaretRight v-if="open" />
				<PhCaretDown v-else />
			</IconButton>
		</PopoverTrigger>
		<slot />
	</Popover>
</template>
